/*
 * Copyright (c) 1984-2024 Ceyoniq Technology GmbH
 * All Rights Reserved.
 *
 * Permission to use, copy, modify, and distribute this software and its
 * documentation for any purpose, without fee, and without a written
 * agreement, is not allowed.
 */

import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/auth/callback',
    component: () => import('pages/auth/AuthCallback.vue'),
    name: 'auth-callback',
  },
  {
    path: '/',
    name: 'root',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'index',
        component: () => import('pages/IndexPage.vue'),
      },
      {
        path: 'dashboard/:id',
        name: 'dashboard',
        component: () => import('pages/IndexPage.vue'),
      },
      {
        path: 'no-permission',
        name: 'no-permission',
        component: () => import('pages/NoPermission.vue'),
      },
      {
        path: 'welcome',
        name: 'welcome',
        component: () => import('pages/WelcomePage.vue'),
      },
      {
        path: '/logout',
        component: () => import('pages/auth/LogoutPage.vue'),
        name: 'logout',
      },
    ],
  },
  {
    path: '/administration',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAdministration: true },
    children: [
      {
        path: '',
        name: 'administration',
        component: () => import('pages/administration/AdministrationPage.vue'),
      },
      {
        path: 'active-contracts/history',
        name: 'administration-active-contracts-history',
        component: () => import('pages/administration/AdminActiveContractsHistoryPage.vue'),
      },
      {
        path: 'translations',
        name: 'administration-translations',
        component: () => import('pages/administration/AdminTranslationsPage.vue'),
      },
      {
        path: 'valuesets',
        name: 'administration-reference-catalogs',
        component: () => import('pages/administration/AdminReferenceCatalogsPage.vue'),
      },
      {
        path: 'additional-properties',
        name: 'administration-additional-properties',
        component: () => import('pages/administration/AdminAdditionalPropertiesPage.vue'),
      },
      {
        path: 'hidden-fields',
        name: 'administration-hidden-fields',
        component: () => import('pages/administration/AdminHiddenFieldsPage.vue'),
      },
      {
        path: 'general-settings',
        name: 'administration-general-settings',
        component: () => import('pages/administration/AdminGeneralSettingsPage.vue'),
      },
      {
        path: 'help-content',
        name: 'administration-help-content',
        component: () => import('pages/administration/AdminHelpContentPage.vue'),
      },
      {
        path: 'api-spec',
        name: 'administration-api-spec',
        component: () => import('pages/administration/AdminApiSpecPage.vue'),
      },
      {
        path: 'api-keys',
        name: 'administration-api-keys',
        component: () => import('pages/administration/AdminApiKeysPage.vue'),
      },
    ],
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
